import { useAuthAxios } from '@/backend/utils';
import authHeader from '@/backend/auth/auth-header';

const http = useAuthAxios();

const API_PREFIX = '/orders/v2/';
const ERP_PURE_BIDDING_PREFIX = '/pure-bidding/';

function serializeParams(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === undefined || item === null) return;
        search.append(key, String(item));
      });
      return;
    }
    search.append(key, String(value));
  });
  return search.toString();
}

export function fetchPureOrders(params) {
  return http.get(API_PREFIX + 'orders', {
    params,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    paramsSerializer: { serialize: serializeParams },
  }).then((res) => res.data);
}

export function exportPureOrders(params) {
  return http.get(ERP_PURE_BIDDING_PREFIX + 'export', {
    params,
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ...authHeader(),
    },
    paramsSerializer: { serialize: serializeParams },
  });
}

export function fetchPureOrder(uid) {
  return http.get(API_PREFIX + 'orders/' + encodeURIComponent(uid), {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
}

export function fetchPureCityOptions(params) {
  return http.get(API_PREFIX + 'orders/cities', {
    params,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    paramsSerializer: { serialize: serializeParams },
  }).then((res) => res.data);
}
